import { useState } from "react";
import { Slider } from "../ui/slider";
import { ReadAloud } from "../brand/Experience";

const scaleColor = (v) => (v >= 7 ? "text-red-600" : v >= 4 ? "text-amber-600" : "text-emerald-600");

export const ScaleInput = ({ label, value, onChange, testId }) => (
  <div className="rounded-2xl bg-white/90 p-5 shadow-sm ring-1 ring-black/5">
    <div className="mb-4 flex items-center justify-between">
      <span className="flex items-center gap-2 text-lg font-semibold text-[#0A2540]">{label}<ReadAloud testId={`${testId}-read`} label="" text={`${label} De zéro, aucune, à dix, maximale.`} /></span>
      <span data-testid={`${testId}-value`} className={`font-display text-4xl font-extrabold ${scaleColor(value)}`}>{value}</span>
    </div>
    <Slider data-testid={testId} min={0} max={10} step={1} value={[value]} onValueChange={([v]) => onChange(v)} className="py-3" />
    <div className="mt-2 flex justify-between text-xs font-medium text-slate-500"><span>0 · aucune</span><span>10 · maximale</span></div>
  </div>
);

export const useScales = (p = 0, f = 0) => {
  const [pain, setPain] = useState(p);
  const [fatigue, setFatigue] = useState(f);
  return { pain, setPain, fatigue, setFatigue };
};

export const PauseNotice = ({ text }) => (
  <div data-testid="pain-pause-notice" role="alert" className="rounded-2xl border-2 border-red-500 bg-red-50 p-4 text-base font-semibold text-red-700">
    {text}
  </div>
);
